/**
 * Types for the saved-designs feature, mirroring
 * `apps/api/src/app/schemas/designs.py`.
 */

export type DesignModule =
  | 'columns'
  | 'beams'
  | 'losas'
  | 'muros'
  | 'zapatas'
  | 'predim'
  // Analysis (NEW) — same Design table, prefix `analysis_` to filter.
  | 'analysis_beams'
  | 'analysis_columns'
  | 'analysis_losas'
  | 'analysis_muros'
  | 'analysis_zapatas';

/** Human-readable labels per module — used by the list page header. */
export const MODULE_LABELS: Record<DesignModule, string> = {
  columns: 'Columnas',
  beams: 'Vigas',
  losas: 'Losas',
  muros: 'Muros',
  zapatas: 'Zapatas',
  predim: 'Predimensionamiento',
  analysis_beams: 'Análisis · Vigas',
  analysis_columns: 'Análisis · Columnas',
  analysis_losas: 'Análisis · Losas',
  analysis_muros: 'Análisis · Muros',
  analysis_zapatas: 'Análisis · Zapatas',
};

export interface DesignListItem {
  id: number;
  module: DesignModule | string;
  subtype: string | null;
  name: string;
  description: string;
  project: string;
  summary: string;
  created_at: string;
  updated_at: string;
}

export interface DesignFull extends DesignListItem {
  payload: Record<string, unknown>;
}

export interface DesignListResponse {
  items: DesignListItem[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
}

export interface DesignCreatePayload {
  module: DesignModule;
  subtype?: string | null;
  name: string;
  description?: string;
  project?: string;
  payload: Record<string, unknown>;
}

export interface DesignUpdatePayload {
  name?: string;
  description?: string;
  project?: string;
  subtype?: string | null;
  payload?: Record<string, unknown>;
}
